.viewport {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: var(--space-6);
}

.panel {
  width: min(100%, 42rem);
  display: grid;
  gap: var(--space-5);
}

.eyebrow {
  color: var(--negative);
  font-family: var(--font-display);
  font-size: var(--text-2xs);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
}

.copy {
  color: var(--ink-secondary);
  max-width: var(--measure-prose);
}

.reference {
  display: grid;
  gap: var(--space-1);
  color: var(--ink-secondary);
  font-size: var(--text-sm);
}

.reference code {
  color: var(--ink-primary);
  font-family: var(--font-mono);
  overflow-wrap: anywhere;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}
